import * as z from "zod/v4";

export const getStorageLocationFilterLocations = {
  name: "getStorageLocationFilterLocations" as const,
  input: z.object({ search: z.string().nullish() }),
  output: z.object({
    locations: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
};
